import React, { useState } from 'react';
import { Mail, CheckCircle2 } from 'lucide-react';
import { api } from '../admin/api';

const WhitelistForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post('/api/users/subscribe', { email, source: 'whitelist' }, { auth: false });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again, or email us at invest@azuramobility.com.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="whitelist" className="py-24 px-6 bg-neutral-50 scroll-mt-24">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <span className="eyebrow justify-center flex">Reserve Your Spot</span>
          <h2 className="text-3xl md:text-4xl font-figtree font-black text-bg-dark tracking-tight mb-4">
            Join the whitelist. <span className="text-accent-amber italic">Get the whitepaper.</span>
          </h2>
          <p className="text-neutral-600 font-exo text-base max-w-lg mx-auto leading-relaxed">
            Submit your email to secure Strategic Round access before it opens, and download the full Azura whitepaper right away.
          </p>
        </div>

        {!submitted ? (
          <div className="bg-white rounded-3xl border border-border shadow-card p-8">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs font-figtree font-bold uppercase tracking-[0.15em] text-neutral-500 mb-2">Email Address</label>
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com"
                  className="w-full bg-neutral-50 border border-border rounded-xl px-4 py-3 text-base font-exo text-bg-dark placeholder-neutral-400 focus:outline-none focus:border-bg-dark transition-all" />
              </div>
              {error && <p className="text-red-600 text-sm font-exo">{error}</p>}
              <button type="submit" disabled={loading}
                className="w-full py-4 rounded-full bg-bg-dark text-white font-figtree font-bold text-xs uppercase tracking-wider hover:bg-accent-amber hover:text-bg-dark active:scale-[0.98] disabled:opacity-60 flex items-center justify-center gap-2 transition-all shadow-capsule">
                {loading
                  ? <><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />Submitting...</>
                  : <><Mail size={15} />Join Whitelist & Get White Paper</>}
              </button>
            </form>
          </div>
        ) : (
          <div className="bg-white rounded-3xl border border-border p-12 text-center shadow-card">
            <div className="w-16 h-16 rounded-full bg-accent-amber-light border border-accent-amber/30 flex items-center justify-center mx-auto mb-5 animate-float">
              <CheckCircle2 size={30} className="text-bg-dark" />
            </div>
            <h3 className="text-2xl font-figtree font-black text-bg-dark mb-3">You're Whitelisted!</h3>
            <p className="text-neutral-500 font-exo max-w-md mx-auto mb-8 leading-relaxed">
              We'll email you the moment the Strategic Round opens. In the meantime, we have sent the white paper to your email.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default WhitelistForm;
